<template>
  <div class="search-form">
    <b-row>
      <el-radio-group
        v-model="prebuiltStatus"
        class="ml-3"
        size="small"
        @change="chagneFrom"
      >
        <el-radio-button label="N">{{
          $l('btn_unprinted') || '未使用'
        }}</el-radio-button>
        <el-radio-button label="P">{{
          $l('btn_printed') || '已打印'
        }}</el-radio-button>
        <el-radio-button label="Y">{{
          $l('btn_used') || '已使用'
        }}</el-radio-button>
      </el-radio-group>

      <dict-select
        class="ml-2"
        clearable
        v-model="form.createBy"
        :placeholder="$l('table_head_please_creator') || '请选择创建人查询'"
        filterable
        size="small"
        vstyle="width:258px;"
        url="/master/common/dict/baseUserSelect"
        @change="chagneFrom"
      ></dict-select>

      <b-button
        size="sm"
        class="ml-2"
        variant="outline-success"
        @click="batchGeneration()"
        style="width:80px;"
        v-if="allow('B')"
      >
        {{ $l('btn_batchGeneration') || '批量生成' }}
      </b-button>
      <b-button
        size="sm"
        class="ml-2"
        style="width:80px;"
        variant="outline-success"
        @click="batchPrint()"
        v-if="allow('P') && prebuiltStatus != 'P'"
        :disabled="prebuiltStatus == 'Y'"
      >
        {{ $l('btn_batchPrint') || '批量打印' }}
      </b-button>

      <el-badge
        v-if="allow('P') && prebuiltStatus == 'P'"
        :value="checkedCount"
        class="printer-button"
        :class="{ clearable: !!checkedCount }"
      >
        <b-button
          size="sm"
          variant="outline-success"
          v-if="allow('P') && prebuiltStatus == 'P'"
          class="printer-button ml-2"
          :class="{ clearable: !!checkedCount }"
          @click="batchPrint"
        >
          {{ $l('btn_batchPrint') || '批量打印' }}
          <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
        </b-button>
      </el-badge>
    </b-row>
    <BatchCreate
      :visible="batchGenerationVisible"
      v-if="batchGenerationVisible"
      @close="close"
    />
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  prebuiltStatus: 'N',
}
import EditLoading from '@/mixins/edit-loading'
import BatchCreate from '../batch-create'
export default {
  mixins: [EditLoading],
  components: { BatchCreate },
  props: {
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      batchGenerationVisible: false,
      form: { ...initForm },
      prebuiltStatus: 'N',
    }
  },

  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    chagneFrom() {
      this.form.prebuiltStatus = this.prebuiltStatus
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
    },
    batchGeneration() {
      this.batchGenerationVisible = true
    },
    close(flag) {
      this.batchGenerationVisible = false
      if (flag) this.query()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    add() {
      this.$emit('openEditPage', 'add')
    },
    clearCheckboxRow() {
      this.$emit('clearCheckboxRow')
    },
    batchPrint() {
      this.$emit('batchPrint', this.prebuiltStatus)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
::v-deep .el-radio-button__inner {
  width: 93px;
}
.line {
  text-align: center;
}

.printer-button {
  .el-icon-circle-close {
    display: none;
  }
}
.printer-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
